
export default function Solution() {
  const outcomes = [
    {
      icon: 'ri-search-eye-line',
      title: 'See Exactly What\'s Working',
      description: 'We audit your website, Google profile, and online presence. Showing you what attracts customers and what\'s invisible.'
    },
    {
      icon: 'ri-lightbulb-line',
      title: 'Get a Clear Strategy',
      description: 'No jargon, no complexity. Just actionable plans to attract the customers you actually want to work with.'
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Stay Ahead Monthly',
      description: 'Regular insights keep you informed and competitive. So you\'re never guessing what\'s working again.'
    }
  ];

  return (
    <section className="bg-white py-28">
      <div className="max-w-[1100px] mx-auto px-6">
        <div className="text-center mb-20">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#FF6B35]/5 border border-[#FF6B35]/20 rounded-full text-sm mb-6">
            <span className="w-1.5 h-1.5 bg-[#FF6B35] rounded-full"></span>
            <span className="text-[#1A1F36] font-medium">What We Do</span>
          </div>
          <h2 className="text-4xl lg:text-[42px] font-bold text-[#1A1F36] mb-6">
            See What's Working. <span className="text-[#FF6B35]">Fix What's Not.</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-[600px] mx-auto">
            No jargon. No complexity. Just clear insights and strategies that actually work for service businesses.
          </p>
        </div>

        {/* Timeline-style layout */}
        <div className="relative">
          {/* Connecting line */}
          <div className="hidden lg:block absolute top-[60px] left-[calc(16.67%-20px)] right-[calc(16.67%-20px)] h-0.5 bg-gradient-to-r from-[#FF6B35]/20 via-[#FF6B35] to-[#FF6B35]/20"></div>
          
          <div className="grid lg:grid-cols-3 gap-8 lg:gap-12">
            {outcomes.map((outcome, index) => (
              <div 
                key={index}
                className="text-center group"
              >
                {/* Icon circle */}
                <div className="relative inline-flex mb-8">
                  <div className="w-[120px] h-[120px] flex items-center justify-center bg-gradient-to-br from-[#FF6B35]/10 to-[#FF6B35]/5 rounded-full border-2 border-[#FF6B35]/20 group-hover:border-[#FF6B35]/50 group-hover:from-[#FF6B35]/20 group-hover:to-[#FF6B35]/10 transition-all duration-300">
                    <i className={`${outcome.icon} text-4xl text-[#FF6B35]`}></i>
                  </div>
                  {/* Step number */}
                  <div className="absolute -bottom-2 -right-2 w-10 h-10 flex items-center justify-center bg-[#1A1F36] text-white text-sm font-bold rounded-full shadow-lg">
                    {String(index + 1).padStart(2, '0')}
                  </div>
                </div>
                
                <h3 className="text-xl font-bold text-[#1A1F36] mb-3">
                  {outcome.title}
                </h3>
                <p className="text-base text-gray-600 leading-relaxed max-w-[280px] mx-auto">
                  {outcome.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
